import { siteSelectModal, siteSelectModalSplit } from '../config/features';
import { trackingAllowed } from './analytics';

/** How a visitor is given the choice of where to order from: a page of its own, or a modal over the menu. */
export type SiteSelectVariant = 'page' | 'modal';

const STORAGE_KEY = 'site_select_variant_assigned';

type Inputs = {
    /** the operator has the modal for everyone */
    always: boolean;
    /** the operator has the modal for half of their visitors */
    split: boolean;
    /** the visitor may be given one at random and have it kept (not so for those who asked not to be tracked) */
    mayAssign: boolean;
    stored: string | null;
    random: number;
};

/** Which one a visitor gets. Kept apart from the browser so that it can be tested. */
export const resolveSiteSelectVariant = ({ always, split, mayAssign, stored, random }: Inputs): SiteSelectVariant => {
    if (always) return 'modal';
    if (!split || !mayAssign) return 'page';
    if (stored === 'page' || stored === 'modal') return stored;

    return random < 0.5 ? 'modal' : 'page';
};

let chosen: SiteSelectVariant | null = null;

/** Which one this visitor gets: the same each time they come back, and the same for every page they go through. */
export const getSiteSelectVariant = (): SiteSelectVariant => {
    if (chosen) return chosen;

    let stored: string | null = null;

    try {
        stored = localStorage.getItem(STORAGE_KEY);
    } catch {
        // (storage is off: they get one for as long as the page is open)
    }

    chosen = resolveSiteSelectVariant({
        always: siteSelectModal,
        split: siteSelectModalSplit,
        mayAssign: trackingAllowed(),
        stored,
        random: Math.random(),
    });

    if (siteSelectModalSplit && !siteSelectModal && trackingAllowed()) {
        try {
            localStorage.setItem(STORAGE_KEY, chosen);
        } catch {
            // (as above)
        }
    }

    return chosen;
};

/** Only for tests: forgets the one chosen. */
export const resetSiteSelectVariant = () => {
    chosen = null;
};
